import './Banner.scss';
import 'animate.css';



const Banner =() => {
  return (
    <div className='banner'>
      
      <div className='banner-pics-container'>

       <p className='title_pics'> skinny tattoo </p> 

      </div>
    </div>
  )
}

export default Banner;